export default {
  build: 'mq-ca4b351',
  builtAt: '1793706989',
};
